import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import REGEXP from '@/common/regexp';
import { API_URL } from '@/dtos';

export const GET_ELECTION_AMOUNT_QUERY_KEY = 'GET_ELECTION_AMOUNT_QUERY_KEY';
export interface ElectionAmountResponse {
  maxElectionAmount: number;
  minElectionAmount: number;
}

const hasEightDigits = (d?: string) => !!d && d.replace(REGEXP.ALL_NON_NUMERIC, '').length >= 8;

export const useGetElectionAmount = (id?: string, date?: string, defaultDate?: string) => {
  const { data, isSuccess, isLoading } = useQuery(
    [GET_ELECTION_AMOUNT_QUERY_KEY, id, date],
    () =>
      api.get(API_URL.PLANS_ELECTION_AMOUNT_BY_PLAN_ID(id || ''), {
        params: {
          effective_date: date || defaultDate,
        },
      }),
    {
      enabled: Boolean(id) && hasEightDigits(date || defaultDate),
      retry: 0,
    }
  );

  return {
    maxElectionAmount: data?.data?.maxElectionAmount,
    minElectionAmount: data?.data?.minElectionAmount,
    isLoading,
    isSuccess,
  };
};

export default useGetElectionAmount;
